module.exports = __webpack_public_path__ + "static/media/TW-AFLDraft-desktop-2440x300.2e987436.jpg";